<div class="lum-rfq-inventory-orders-table__component">
  <h2 mat-dialog-title>
    [{{ data?.rfq.internal_sku }}] {{ data?.rfq.product_name }}
  </h2>
  <div class="lum-rfq-inventory-orders-table__component__table-wrapper">
    <table class="lum-table lum-table--classic">
      <thead>
        <tr>
          <th>Order Date</th>
          <th>Purchase Order #</th>
          <th>Quantity</th>
          <th>Supplier</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!(loading$ | async); else loading">
          <ng-container *ngIf="incomingOrders.length > 0; else noOrders">
            <tr *ngFor="let order of incomingOrders; trackBy: trackById">
              <td>
                {{ order?.supplierPurchaseOrder?.orderDate | date: 'mediumDate' }}
              </td>
              <td>
                <a
                  class="cursor-pointer text-primary text-underline"
                  (click)="onViewOrder(order)"
                >
                  {{ order?.purchaseOrderId }}
                </a>
              </td>
              <td>
                {{ order?.remainingIncoming | decimalPlaces }}
              </td>
              <td>
                {{
                  order?.supplierPurchaseOrder?.factory?.factoryName ||
                    order?.supplierPurchaseOrderItem?.supplierPurchaseOrder?.factory
                      ?.factoryName ||
                    '---'
                }}
              </td>
            </tr>
          </ng-container>
          <ng-template #noOrders>
            <tr>
              <td colspan="5">
                <div class="d-flex align-items-center justify-content-center">
                  <p>No incoming orders found</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </ng-container>

        <ng-template #loading>
          <tr>
            <td colspan="5">
              <div
                class="
                  lum-rfq-inventory-orders-table__component__table-wrapper__loading d-flex align-items-center justify-content-center
                "
              >
                <mat-spinner diameter="20"></mat-spinner> Loading...
              </div>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
